var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_291_335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_291_335",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_291_335",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_291_335",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADHElEQVR4nO2cy0uVQRiHn7IiWxRUWhCVYm2jRURRQkhJLVp2sxZBRaCL/oWWYdCFLojYKvMfCNq0ikrDMqOrWEE7IU83AsssJz54PxCxyzmcM/M68z7w2+iB4/swZ5zvnTkDhmEYhmEYhmEYRkmsA9qAHuAx8AH4ISnIz7LftQINpb1FuswDDgO9gCsy94EWoCp0EdrZDQyXIHh6hoDm0MVoZBHQVQbB09MJVIcuTgu1wEAFJOd5CNSQOLXyMa+U5KlTSU3K08WAB8lTR/ZCEqTLo+Q8HSRGcwDJefaQ0Dp5OKDoV6mss48ElJznIAnQp0D0PRLoXTgFmQTqiZg2BZLznCRiehQIztNNxAwqEJznERFTUCA4z3siZlyB4DzfiRinLNHilCVanLJEy7gCuUnM0QUFgpNYdQwqEJzEOvqGAsF5rhMxrQoEJ9HraJDOWWjJ2d9QR+T0KhB9lwRoUSB6PwlQ5eksx5/yIpU9w4xdAUU3kRidASRfJUGq5fSQL8kPUj2phJyHG/J0lmM5iVMD9Fd4JCd7wHGmaaSjQnNystPF39gpH/NyLOGSW10US7bGPSSniYp5XJ+UJ74DwNyi3zVx6qX50y1nqQuyeZBlVFqd3fKa6HsXhmEYhmEYhmEYybAE2AqcAC4At6QDl7VTR4BvkhHpi/TJa84Dx4EtwOLQRWhkpWzYXgPelrFz90a+nZv1TVaQKBuBduC5h6Z/3nB6CpwBNhA5a4BTcj2PD7n/aqOeBtYTEduBm0pOKM000m8De4E5zEIWAMeAZwpkuv/ME+AoMJ9ZQjY6XisQ50pMdiHAPs0jfLPsirhIcgfYhLJrIbJ/LD8VyHFlzi/goobppE7umnORp18uDAjCDuCzAgnOUz4Bjb4lN8pjsEssY8A2X5KXyQ60SzSjwFIfos8pKNYFzlkfokNePOWU5KUP0WMKCnWB89WH6HcKCnWBk7VgK84lBYW6wMk2GSrOKuCjgmJdoGTPDqvx+GWfLwqKdgEeWppCnPS8IquQCQUSXIUyITVeBtb6lmwYhmEYhmEYhmEYhoFCfgNnsqKzarSQ4AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.eabfc826035818a4e4374a0f781e651a.svg";
export { ForwardRef as ReactComponent };